export const APP_VERSION = '3.9.0';
